<!-- **** --------------------------------------------------------------------------
	SHARED SCRIPT
-------------------------------------------------------------------------- **** -->
<script lang="ts">
    // assets
    import { SmallArrowDownSVG, SmallArrowUpSVG } from '@shared/assets/vector/ui/IconsUI';
    import { reactive } from 'vue';

    // this is mostly for debugging, otherwise components are Anonymous
    const component = {
        name: 'Input_NativeSelect',
    };
    export default {
        name: component.name,
    };
</script>

<!-- **** --------------------------------------------------------------------------
	SCRIPT
-------------------------------------------------------------------------- **** -->
<script lang="ts" setup>
    const props = defineProps<{
        value: any;
        valueModifiers?: any;
    }>();

    const state = reactive({
        open: false,
    });

    const updateValue = (emit: any, value: any) => {
        // string too boolean...
        if (props.valueModifiers?.boolean) value = value === 'true';

        emit('update:value', value);
    };
</script>

<!-- **** --------------------------------------------------------------------------
	TEMPLATE
-------------------------------------------------------------------------- **** -->
<template>
    <div class="input-wrapper field inner-button right" data-type="pickerinput">
        <select
            class="native plain"
            :value="value"
            @change="updateValue($emit, ($event.target as any).value)"
            @focus="state.open = true"
            @blur="state.open = false">
            <slot name="options"></slot>
        </select>
        <component :is="state.open ? SmallArrowUpSVG : SmallArrowDownSVG"></component>
    </div>
</template>

<!-- **** --------------------------------------------------------------------------
	STYLES
-------------------------------------------------------------------------- **** -->
<style>
    select.native {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-image: none !important; /* clashes with select rule in ungapped.css */
        padding-right: 2.4rem !important; /* same */

        box-shadow: none;
    }

    select.native > option {
        font-size: 0.95rem;
        padding: 1rem;
    }

    select.native + svg {
        pointer-events: none;
    }
</style>
